export default "__VITE_ASSET__DiBbz5id__"